/* eslint-disable react/prop-types */
import { Box, Grid } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import AppointMentBoolInput from "../../../../components/AppointMentBoolInput/AppointMentBoolInput";
import InputField from "../../../../components/common/new/InputField/InputField";
import Typography from "../../../../components/common/new/Typography/Typography";
import {
  STRUCTURE_LEVEL,
  STRUCTURE_LEVEL_LIST,
} from "../../../../contants/appointment";
import { APPOINTMENT_ENTRY } from "../../../../contants/formFields";
import { selectAllSIUsers } from "../../../../redux/selectors/user";
import { SelectMonthAndYear } from "../../../../components/common/new/YearAndMonthDropDown/YearAndMonthDropDown";

function LeaderForm({
  values,
  handleChange,
  readOnly,
  setFieldValue,
  structureLevel,
}) {
  const {
    isDistrictSi,
    isChapterSi,
    isRegionSi,
    isZoneSi,
    isAreaSi,
    isDistrictLeader,
    isChapterLeader,
    isRegionLeader,
    isZoneLeader,
    isAreaLeader,
    isHelpDesk,
    isHelpDeskAdmin,
  } = useSelector(selectAllSIUsers);

  const districtChief = isDistrictSi || isDistrictLeader;
  const chapterChief = isChapterSi || isChapterLeader;
  const regionChief = isRegionSi || isRegionLeader;
  const zoneChief = isZoneSi || isZoneLeader;
  const areaChief = isAreaSi || isAreaLeader;

  // Block Chief
  if (
    districtChief ||
    (chapterChief && structureLevel === STRUCTURE_LEVEL.BLOCK) ||
    (regionChief && structureLevel === STRUCTURE_LEVEL.BLOCK) ||
    (zoneChief && structureLevel === STRUCTURE_LEVEL.BLOCK) ||
    (areaChief && structureLevel === STRUCTURE_LEVEL.BLOCK)
  ) {
    return (
      <>
        <Box sx={{ p: { xs: 2, md: 3 } }}>
          <Box
            sx={{
              background: "#FFF",
              borderRadius: "12px",
              border: "1px solid #E0E0E0",
              overflow: "hidden",
              boxShadow: "0px 2px 8px rgba(0,0,0,0.06)",
            }}
          >
            <Box
              sx={{
                background: "linear-gradient(135deg, #196AAB 0%, #1976d2 100%)",
                px: 3,
                py: 2,
              }}
            >
              <Typography
                sx={{
                  color: "#FFF",
                  fontSize: "16px",
                  fontWeight: 600,
                  fontFamily: "'Inter', sans-serif",
                }}
              >
                Appointment Criteria (Block Chief)
              </Typography>
            </Box>

            <Box sx={{ p: { xs: 2.5, md: 4 }, background: "#FAFAFA" }}>
              <Grid container spacing={3.5} sx={{ flexWrap: "nowrap" }}>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      background: "#FFF",
                      p: 2.5,
                      borderRadius: "8px",
                      border: "1px solid #E8E8E8",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "0.875rem",
                        fontWeight: 600,
                        color: "#1E293B",
                        mb: 0.5,
                        fontFamily: "'Inter', sans-serif",
                      }}
                    >
                      Doing Gongyo & Daimoku Regularly, Attending BSG Meetings
                      <Typography
                        component="span"
                        sx={{ color: "#FF6A69", ml: 0.5 }}
                      >
                        *
                      </Typography>
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: ".80rem",
                        color: "#000000ff",
                        mb: 2,
                        fontFamily: "'Inter', sans-serif",
                      }}
                    >
                      (Discussion Meeting & Gosho Study Meetings) with active
                      practice of more than 1 year for MD/WD (6 month for
                      YMD/YWD)
                    </Typography>
                    <SelectMonthAndYear
                      name={APPOINTMENT_ENTRY.DOING_GONGYO_AND_DAIKOMU}
                      value={values[APPOINTMENT_ENTRY.DOING_GONGYO_AND_DAIKOMU]}
                      readOnly={readOnly}
                      setFieldValue={setFieldValue}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    sx={{
                      background: "#FFF",
                      p: 2.5,
                      borderRadius: "8px",
                      border: "1px solid #E8E8E8",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "0.875rem",
                        fontWeight: 600,
                        color: "#1E293B",
                        mb: 0.5,
                        fontFamily: "'Inter', sans-serif",
                      }}
                    >
                      Position Held in Youth Division, if Being Appointed
                      Directly Upon Graduation-
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "0.80rem",
                        color: "#000000ff",
                        mb: 2,
                        fontFamily: "'Inter', sans-serif",
                      }}
                    >
                      (Chapter Chief/ District Chief for Block Chief
                      appointment)
                    </Typography>
                    <InputField
                      label="Positions held in Youth Division"
                      name={APPOINTMENT_ENTRY.POSITION_HELD_IN_YOUTH_DIVISION}
                      value={
                        values[
                          APPOINTMENT_ENTRY.POSITION_HELD_IN_YOUTH_DIVISION
                        ]
                      }
                      onChange={handleChange}
                      disabled={readOnly}
                      fullWidth
                      sx={{ mt: "10px" }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
        <Box style={{ margin: "1.5rem -33px" }} />
      </>
    );
  }

  // District Chief
  if (
    (chapterChief && structureLevel !== STRUCTURE_LEVEL.BLOCK) ||
    (regionChief && structureLevel === STRUCTURE_LEVEL.DISTRICT) ||
    (zoneChief && structureLevel === STRUCTURE_LEVEL.DISTRICT) ||
    (areaChief && structureLevel === STRUCTURE_LEVEL.DISTRICT)
  ) {
    return (
      <>
        <Box sx={{ p: { xs: 2, md: 3 } }}>
          <Box
            sx={{
              background: "#FFF",
              borderRadius: "12px",
              border: "1px solid #E0E0E0",
              overflow: "hidden",
              boxShadow: "0px 2px 8px rgba(0,0,0,0.06)",
            }}
          >
            <Box
              sx={{
                background: "linear-gradient(135deg, #196AAB 0%, #1976d2 100%)",
                px: 3,
                py: 2,
              }}
            >
              <Typography
                sx={{
                  color: "#FFF",
                  fontSize: "16px",
                  fontWeight: 600,
                  fontFamily: "'Inter', sans-serif",
                }}
              >
                Appointment Criteria (District Chief)
              </Typography>
            </Box>

            <Box sx={{ p: { xs: 2.5, md: 4 }, background: "#FAFAFA" }}>
              <Grid container spacing={3.5}>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      background: "#FFF",
                      p: 2.5,
                      borderRadius: "8px",
                      border: "1px solid #E8E8E8",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "0.875rem",
                        fontWeight: 600,
                        color: "#1E293B",
                        mb: 0.5,
                        fontFamily: "'Inter', sans-serif",
                      }}
                    >
                      Years of Active Practice
                      <Typography
                        component="span"
                        sx={{ color: "#FF6A69", ml: 0.5 }}
                      >
                        *
                      </Typography>
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "0.75rem",
                        color: "#64748B",
                        mb: 2,
                        fontFamily: "'Inter', sans-serif",
                      }}
                    >
                      (More than 2 years for MD/WD more than 1 year for YMD/YWD)
                    </Typography>
                    <SelectMonthAndYear
                      name={APPOINTMENT_ENTRY.YEARS_OF_ACTIVE_PRACTICE}
                      value={values[APPOINTMENT_ENTRY.YEARS_OF_ACTIVE_PRACTICE]}
                      readOnly={readOnly}
                      setFieldValue={setFieldValue}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    sx={{
                      background: "#FFF",
                      p: 2.5,
                      borderRadius: "8px",
                      border: "1px solid #E8E8E8",
                    }}
                  >
                    <AppointMentBoolInput
                      labelStyles={{
                        width: "68%",
                        paddingRight: "60px",
                      }}
                      name={APPOINTMENT_ENTRY.HAS_BEEN_BLOCK_CHEIF}
                      value={values[APPOINTMENT_ENTRY.HAS_BEEN_BLOCK_CHEIF]}
                      handleChange={handleChange}
                      preLabel="Has been Block Chief for more than 1 year of which 6 months as main BC in MD/ WD (6 months as Block Chief in YMD/ YWD)"
                      readOnly={readOnly}
                      required
                    />
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    sx={{
                      background: "#FFF",
                      p: 2.5,
                      borderRadius: "8px",
                      border: "1px solid #E8E8E8",
                    }}
                  >
                    <AppointMentBoolInput
                      name={APPOINTMENT_ENTRY.ATTENDING_MEETING}
                      value={values[APPOINTMENT_ENTRY.ATTENDING_MEETING]}
                      handleChange={handleChange}
                      labelStyles={{
                        width: "68%",
                        paddingRight: "60px",
                      }}
                      preLabel="Attending Discussion Meeting, District Planning Meetings, Gosho/ NHR Study Meeting and other leaders meeting such as DOU, etc"
                      readOnly={readOnly}
                      required
                    />
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    sx={{
                      background: "#FFF",
                      p: 2.5,
                      borderRadius: "8px",
                      border: "1px solid #E8E8E8",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "0.875rem",
                        fontWeight: 600,
                        color: "#1E293B",
                        mb: 0.5,
                        fontFamily: "'Inter', sans-serif",
                      }}
                    >
                      Position Held in Youth Division if Being Appointed
                      Directly Upon Graduation
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "0.75rem",
                        color: "#64748B",
                        mb: 2,
                        fontFamily: "'Inter', sans-serif",
                      }}
                    >
                      (RC or above for District Chief appointment)
                    </Typography>
                    <InputField
                      name={APPOINTMENT_ENTRY.POSITION_HELD_IN_YOUTH_DIVISION}
                      value={
                        values[
                          APPOINTMENT_ENTRY.POSITION_HELD_IN_YOUTH_DIVISION
                        ]
                      }
                      onChange={handleChange}
                      label="Positions held in Youth Division"
                      disabled={readOnly}
                      fullWidth
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
        <Box style={{ margin: "1.5rem -33px" }} />
      </>
    );
  }

  // Chapter Chief
  if (
    (regionChief &&
      !STRUCTURE_LEVEL_LIST.slice(0, 2).includes(structureLevel)) ||
    (zoneChief && structureLevel === STRUCTURE_LEVEL.CHAPTER) ||
    (areaChief && structureLevel === STRUCTURE_LEVEL.CHAPTER)
  ) {
    return (
      <>
        <Box sx={{ p: { xs: 2, md: 3 } }}>
          <Box
            sx={{
              background: "#FFF",
              borderRadius: "12px",
              border: "1px solid #E0E0E0",
              overflow: "hidden",
              boxShadow: "0px 2px 8px rgba(0,0,0,0.06)",
            }}
          >
            <Box
              sx={{
                background: "linear-gradient(135deg, #196AAB 0%, #1976d2 100%)",
                px: 3,
                py: 2,
              }}
            >
              <Typography
                sx={{
                  color: "#FFF",
                  fontSize: "16px",
                  fontWeight: 600,
                  fontFamily: "'Inter', sans-serif",
                }}
              >
                Appointment Criteria (Chapter Chief)
              </Typography>
            </Box>

            <Box sx={{ p: { xs: 2.5, md: 4 }, background: "#FAFAFA" }}>
              <Grid container spacing={3.5}>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      background: "#FFF",
                      p: 2.5,
                      borderRadius: "8px",
                      border: "1px solid #E8E8E8",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "0.875rem",
                        fontWeight: 600,
                        color: "#1E293B",
                        mb: 0.5,
                        fontFamily: "'Inter', sans-serif",
                      }}
                    >
                      Years of Active Practice
                      <Typography
                        component="span"
                        sx={{ color: "#FF6A69", ml: 0.5 }}
                      >
                        *
                      </Typography>
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "0.75rem",
                        color: "#64748B",
                        mb: 2,
                        fontFamily: "'Inter', sans-serif",
                      }}
                    >
                      (More than 4 years for MD/WD more than 2 year for YMD/YWD)
                    </Typography>
                    <SelectMonthAndYear
                      name={APPOINTMENT_ENTRY.YEARS_OF_ACTIVE_PRACTICE}
                      value={values[APPOINTMENT_ENTRY.YEARS_OF_ACTIVE_PRACTICE]}
                      readOnly={readOnly}
                      setFieldValue={setFieldValue}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    sx={{
                      background: "#FFF",
                      p: 2.5,
                      borderRadius: "8px",
                      border: "1px solid #E8E8E8",
                    }}
                  >
                    <AppointMentBoolInput
                      labelStyles={{
                        width: "68%",
                        paddingRight: "60px",
                      }}
                      name={APPOINTMENT_ENTRY.HAS_BEEN_DISTRICT_CHIEF}
                      value={values[APPOINTMENT_ENTRY.HAS_BEEN_DISTRICT_CHIEF]}
                      handleChange={handleChange}
                      preLabel="Has been MD/WD DC/DDC for more than 2 years (1 year for YMD/YWD) out of which at least 1 year should be main DC not deputy (6 months for YMD/YWD)"
                      readOnly={readOnly}
                      required
                    />
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    sx={{
                      background: "#FFF",
                      p: 2.5,
                      borderRadius: "8px",
                      border: "1px solid #E8E8E8",
                    }}
                  >
                    <AppointMentBoolInput
                      labelStyles={{
                        width: "68%",
                        paddingRight: "60px",
                      }}
                      name={APPOINTMENT_ENTRY.ATTENDING_MEETING}
                      value={values[APPOINTMENT_ENTRY.ATTENDING_MEETING]}
                      handleChange={handleChange}
                      preLabel="Is actively attending leaders meetings DOU, Gosho / NHR Study Meetings and conducting monthly discussion meetings and district planning meetings"
                      readOnly={readOnly}
                      required
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
        <Box style={{ margin: "1.5rem -33px" }} />
      </>
    );
  }

  // Region Chief
  if (
    (zoneChief && !STRUCTURE_LEVEL_LIST.slice(0, 3).includes(structureLevel)) ||
    (areaChief && structureLevel === STRUCTURE_LEVEL.REGION)
  ) {
    return (
      <>
        <Box sx={{ p: { xs: 2, md: 3 } }}>
          <Box
            sx={{
              background: "#FFF",
              borderRadius: "12px",
              border: "1px solid #E0E0E0",
              overflow: "hidden",
              boxShadow: "0px 2px 8px rgba(0,0,0,0.06)",
            }}
          >
            <Box
              sx={{
                background: "linear-gradient(135deg, #196AAB 0%, #1976d2 100%)",
                px: 3,
                py: 2,
              }}
            >
              <Typography
                sx={{
                  color: "#FFF",
                  fontSize: "16px",
                  fontWeight: 600,
                  fontFamily: "'Inter', sans-serif",
                }}
              >
                Appointment Criteria (Region Chief)
              </Typography>
            </Box>

            <Box sx={{ p: { xs: 2.5, md: 4 }, background: "#FAFAFA" }}>
              <Grid container spacing={3.5}>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      background: "#FFF",
                      p: 2.5,
                      borderRadius: "8px",
                      border: "1px solid #E8E8E8",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "0.875rem",
                        fontWeight: 600,
                        color: "#1E293B",
                        mb: 0.5,
                        fontFamily: "'Inter', sans-serif",
                      }}
                    >
                      Years of Active Practice
                      <Typography
                        component="span"
                        sx={{ color: "#FF6A69", ml: 0.5 }}
                      >
                        *
                      </Typography>
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "0.75rem",
                        color: "#64748B",
                        mb: 2,
                        fontFamily: "'Inter', sans-serif",
                      }}
                    >
                      (More than 6 years for MD/WD more than 3 year for YMD/YWD)
                    </Typography>
                    <SelectMonthAndYear
                      name={APPOINTMENT_ENTRY.YEARS_OF_ACTIVE_PRACTICE}
                      value={values[APPOINTMENT_ENTRY.YEARS_OF_ACTIVE_PRACTICE]}
                      readOnly={readOnly}
                      setFieldValue={setFieldValue}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    sx={{
                      background: "#FFF",
                      p: 2.5,
                      borderRadius: "8px",
                      border: "1px solid #E8E8E8",
                    }}
                  >
                    <AppointMentBoolInput
                      labelStyles={{
                        width: "68%",
                        paddingRight: "60px",
                      }}
                      name={APPOINTMENT_ENTRY.HAS_BEEN_CHAPTER_CHEIF}
                      value={values[APPOINTMENT_ENTRY.HAS_BEEN_CHAPTER_CHEIF]}
                      handleChange={handleChange}
                      preLabel="Has been MD/WD DC/DDC for more than 2 years (1 year for YMD/YWD) out of which at least 1 year (6 months for YMD/YWD) should be main CC not deputy"
                      readOnly={readOnly}
                      required
                    />
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    sx={{
                      background: "#FFF",
                      p: 2.5,
                      borderRadius: "8px",
                      border: "1px solid #E8E8E8",
                    }}
                  >
                    <AppointMentBoolInput
                      labelStyles={{
                        width: "68%",
                        paddingRight: "60px",
                      }}
                      name={
                        APPOINTMENT_ENTRY.ATTENDING_BSG_MEETING_INCLUDING_NHR_GOSHO
                      }
                      value={
                        values[
                          APPOINTMENT_ENTRY
                            .ATTENDING_BSG_MEETING_INCLUDING_NHR_GOSHO
                        ]
                      }
                      handleChange={handleChange}
                      preLabel="Is regularly attending BSG meetings including NHR/ Gosho Study Meeting"
                      readOnly={readOnly}
                      required
                    />
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    sx={{
                      background: "#FFF",
                      p: 2.5,
                      borderRadius: "8px",
                      border: "1px solid #E8E8E8",
                    }}
                  >
                    <AppointMentBoolInput
                      labelStyles={{
                        width: "68%",
                        paddingRight: "60px",
                      }}
                      name={
                        APPOINTMENT_ENTRY.ACTIVELY_PARTICIPATING_LEADER_MEETING
                      }
                      value={
                        values[
                          APPOINTMENT_ENTRY
                            .ACTIVELY_PARTICIPATING_LEADER_MEETING
                        ]
                      }
                      handleChange={handleChange}
                      preLabel="Is actively participating in leader meeting (DOU) and taking monthly Gosho meeting from time to time"
                      readOnly={readOnly}
                      required
                    />
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    sx={{
                      background: "#FFF",
                      p: 2.5,
                      borderRadius: "8px",
                      border: "1px solid #E8E8E8",
                    }}
                  >
                    <AppointMentBoolInput
                      labelStyles={{
                        width: "68%",
                        paddingRight: "60px",
                      }}
                      name={
                        APPOINTMENT_ENTRY.CLEARED_THE_INTRODUCTORY_LEVEL_EXAMINATION_ENTRANCE_EXAM
                      }
                      value={
                        values[
                          APPOINTMENT_ENTRY
                            .CLEARED_THE_INTRODUCTORY_LEVEL_EXAMINATION_ENTRANCE_EXAM
                        ]
                      }
                      handleChange={handleChange}
                      preLabel="Has cleared the Introductory Level Examination (Entrance Exam for YMD/YWD)"
                      readOnly={readOnly}
                      required
                    />
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    sx={{
                      background: "#FFF",
                      p: 2.5,
                      borderRadius: "8px",
                      border: "1px solid #E8E8E8",
                    }}
                  >
                    <AppointMentBoolInput
                      labelStyles={{
                        width: "68%",
                        paddingRight: "60px",
                      }}
                      name={APPOINTMENT_ENTRY.OWN_GOHONZON_OR_FAMILY_GOHONZON}
                      value={
                        values[
                          APPOINTMENT_ENTRY.OWN_GOHONZON_OR_FAMILY_GOHONZON
                        ]
                      }
                      handleChange={handleChange}
                      preLabel="(For MD/ WD/ YMD/YWD) has his/ her own Gohonzon or family Gohonzon if living with practicing member"
                      readOnly={readOnly}
                      required
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
        <Box style={{ margin: "1.5rem -33px" }} />
      </>
    );
  }

  // Zone Chief
  if (
    (areaChief && !STRUCTURE_LEVEL_LIST.slice(0, 4).includes(structureLevel)) ||
    (isHelpDesk && structureLevel === STRUCTURE_LEVEL.ZONE) ||
    (isHelpDeskAdmin && structureLevel === STRUCTURE_LEVEL.ZONE)
  ) {
    return (
      <>
        <Box sx={{ p: { xs: 2, md: 3 } }}>
          <Box
            sx={{
              background: "#FFF",
              borderRadius: "12px",
              border: "1px solid #E0E0E0",
              overflow: "hidden",
              boxShadow: "0px 2px 8px rgba(0,0,0,0.06)",
            }}
          >
            <Box
              sx={{
                background: "linear-gradient(135deg, #196AAB 0%, #1976d2 100%)",
                px: 3,
                py: 2,
              }}
            >
              <Typography
                sx={{
                  color: "#FFF",
                  fontSize: "16px",
                  fontWeight: 600,
                  fontFamily: "'Inter', sans-serif",
                }}
              >
                Appointment Criteria (Zone Chief)
              </Typography>
            </Box>

            <Box sx={{ p: { xs: 2.5, md: 4 }, background: "#FAFAFA" }}>
              <Grid container spacing={3.5}>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      background: "#FFF",
                      p: 2.5,
                      borderRadius: "8px",
                      border: "1px solid #E8E8E8",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "0.875rem",
                        fontWeight: 600,
                        color: "#1E293B",
                        mb: 0.5,
                        fontFamily: "'Inter', sans-serif",
                      }}
                    >
                      Years of Active Practice
                      <Typography
                        component="span"
                        sx={{ color: "#FF6A69", ml: 0.5 }}
                      >
                        *
                      </Typography>
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "0.75rem",
                        color: "#64748B",
                        mb: 2,
                        fontFamily: "'Inter', sans-serif",
                      }}
                    >
                      (More than 8 years for MD/WD more than 4 year for YMD/YWD)
                    </Typography>
                    <SelectMonthAndYear
                      name={APPOINTMENT_ENTRY.YEARS_OF_ACTIVE_PRACTICE}
                      value={values[APPOINTMENT_ENTRY.YEARS_OF_ACTIVE_PRACTICE]}
                      readOnly={readOnly}
                      setFieldValue={setFieldValue}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    sx={{
                      background: "#FFF",
                      p: 2.5,
                      borderRadius: "8px",
                      border: "1px solid #E8E8E8",
                    }}
                  >
                    <AppointMentBoolInput
                      name={APPOINTMENT_ENTRY.HAS_BEEN_REGION_CHEIF}
                      value={values[APPOINTMENT_ENTRY.HAS_BEEN_REGION_CHEIF]}
                      handleChange={handleChange}
                      labelStyles={{
                        width: "68%",
                        paddingRight: "60px",
                      }}
                      preLabel="Has been MD/WD DC/DDC for more than 2 years (1 year for YMD/YWD) out of which at least 1 year should be main RC not deputy"
                      readOnly={readOnly}
                      required
                    />
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    sx={{
                      background: "#FFF",
                      p: 2.5,
                      borderRadius: "8px",
                      border: "1px solid #E8E8E8",
                    }}
                  >
                    <AppointMentBoolInput
                      labelStyles={{
                        width: "68%",
                        paddingRight: "60px",
                      }}
                      name={
                        APPOINTMENT_ENTRY.ACTIVELY_SUPPORTING_LEADERS_MEETING
                      }
                      value={
                        values[
                          APPOINTMENT_ENTRY.ACTIVELY_SUPPORTING_LEADERS_MEETING
                        ]
                      }
                      handleChange={handleChange}
                      preLabel="Actively supporting / conducting leaders meeting, taking monthly Gosho study from time to time and regularly attending Gosho/ NHR meetings"
                      readOnly={readOnly}
                      required
                    />
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    sx={{
                      background: "#FFF",
                      p: 2.5,
                      borderRadius: "8px",
                      border: "1px solid #E8E8E8",
                    }}
                  >
                    <AppointMentBoolInput
                      labelStyles={{
                        width: "68%",
                        paddingRight: "60px",
                      }}
                      name={
                        APPOINTMENT_ENTRY.CLEARED_THE_INTRODUCTORY_LEVEL_EXAMINATION
                      }
                      value={
                        values[
                          APPOINTMENT_ENTRY
                            .CLEARED_THE_INTRODUCTORY_LEVEL_EXAMINATION
                        ]
                      }
                      handleChange={handleChange}
                      preLabel="MD/WD - cleared the Introductory Level Examination (YMD/YWD - cleared the Entrance Level Examination) and has his/ her own Gohonzon or a family Gohonzon if living with practicing family member"
                      readOnly={readOnly}
                      required
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
        <Box style={{ margin: "1.5rem -33px" }} />
      </>
    );
  }

  return null;
}

export default LeaderForm;
